import { useEffect } from 'react';
import { detectOs } from '../../../utils/platform';
import { storeLinkFor } from '../../../utils/appLinks';
import { type AppInstallPageProps } from '../../types';

/**
 * HostedMobileAppInstallPage — Redirects to the appropriate app store.
 *
 * On iOS redirects to Apple App Store, on Android to Google Play.
 * Renders nothing while redirecting.
 */
export default function HostedMobileAppInstallPage({
  appName,
}: AppInstallPageProps) {
  const store = storeLinkFor(appName, detectOs());

  useEffect(() => {
    if (store) window.location.href = store;
  }, [store]);

  return null;
}
